import {i18n} from "@/config/i18n";
import {MONTHLY_DATA, MONTH_LABELS, YTD_DATA} from "@/data/performance";
import tradeLogs from "@/data/trade-logs.json";
import heroPanelData from "@/data/hero-panel.json";

export default {
    data() {
        return {
            heroStats: [
                {value: '30–36%', key: 'home.statReturn'},
                {value: '1.200+', key: 'home.statAccounts'},
                {value: '24/7', key: 'home.statSystem'},
                {value: i18n.global.t('home.statTrackValue'), key: 'home.statTrack'},
            ],
            trustCards: [
                {icon: '01', titleKey: 'home.trustTransparentTitle', descKey: 'home.trustTransparentDesc'},
                {icon: '02', titleKey: 'home.trustReliableTitle', descKey: 'home.trustReliableDesc'},
                {icon: '03', titleKey: 'home.trustFlexibleTitle', descKey: 'home.trustFlexibleDesc'},
            ],
            steps: [
                {titleKey: 'home.step1Title', descKey: 'home.step1Desc'},
                {titleKey: 'home.step2Title', descKey: 'home.step2Desc'},
                {titleKey: 'home.step3Title', descKey: 'home.step3Desc'},
            ],
            chartData: [35, 52, 48, 70, 62, 88, 95],
            benefitCards: [
                {titleKey: 'home.benefitStableTitle', descKey: 'home.benefitStableDesc'},
                {titleKey: 'home.benefitSmartTitle', descKey: 'home.benefitSmartDesc'},
                {titleKey: 'home.benefitSupportTitle', descKey: 'home.benefitSupportDesc'},
            ],
            strategies: [
                {
                    labelKey: 'home.strategy1Label',
                    titleKey: 'home.strategy1Title',
                    descKey: 'home.strategy1Desc',
                    returnRange: '8–12%',
                    drawdown: '-8%',
                    winRate: '68%',
                    sharpe: '1,85',
                    riskLevel: 2,
                    riskLabelKey: 'home.riskLow',
                    featured: false,
                },
                {
                    labelKey: 'home.strategy2Label',
                    titleKey: 'home.strategy2Title',
                    descKey: 'home.strategy2Desc',
                    returnRange: '30–36%',
                    drawdown: '-15%',
                    winRate: '72%',
                    sharpe: '2,14',
                    riskLevel: 3,
                    riskLabelKey: 'home.riskMedium',
                    featured: true,
                },
                {
                    labelKey: 'home.strategy3Label',
                    titleKey: 'home.strategy3Title',
                    descKey: 'home.strategy3Desc',
                    returnRange: '36–45%',
                    drawdown: '-25%',
                    winRate: '65%',
                    sharpe: '1,52',
                    riskLevel: 4,
                    riskLabelKey: 'home.riskHigh',
                    featured: false,
                },
            ],
            pricingRows: [
                {
                    titleKey: 'home.pricing1Title',
                    descKey: 'home.pricing1Desc',
                    value: '10%',
                    noteKey: 'home.pricing1Note',
                    featured: true,
                },
                {
                    titleKey: 'home.pricing2Title',
                    descKey: 'home.pricing2Desc',
                    value: '0%',
                    noteKey: 'home.pricing2Note',
                    featured: false,
                },
                {
                    titleKey: 'home.pricing3Title',
                    descKey: 'home.pricing3Desc',
                    value: '8$ = 200k',
                    noteKey: 'home.pricing3Note',
                    featured: false,
                },
                {
                    titleKey: 'home.pricing4Title',
                    descKey: 'home.pricing4Desc',
                    value: 'T+0',
                    noteKey: 'home.pricing4Note',
                    featured: false,
                },
            ],
            faqs: [
                {qKey: 'home.faq1Q', aKey: 'home.faq1A'},
                {qKey: 'home.faq2Q', aKey: 'home.faq2A'},
                {qKey: 'home.faq3Q', aKey: 'home.faq3A'},
                {qKey: 'home.faq4Q', aKey: 'home.faq4A'},
                {qKey: 'home.faq5Q', aKey: 'home.faq5A'},
            ],
            activeFaq: 0,
            // Tooltip cho bar chart
            tooltip: null, // { x, y, label, team, val, color }
            machineTooltip: null,
            heroTooltip: null, // { x, y, pair, profit, cum, type }
            sparkTooltip: null, // { pxX, pxY, containerW, time, pair, profit, cum }
            vnIndexTooltip: null, // { svgX, svgY, pxX, pxY, containerW, date, value, delta }
            forWhomCards: [
                {
                    titleKey: 'home.forWhom1Title',
                    descKey: 'home.forWhom1Desc',
                    tagKey: 'home.forWhom1Tag',
                },
                {
                    titleKey: 'home.forWhom2Title',
                    descKey: 'home.forWhom2Desc',
                    tagKey: 'home.forWhom2Tag',
                },
                {
                    titleKey: 'home.forWhom3Title',
                    descKey: 'home.forWhom3Desc',
                    tagKey: 'home.forWhom3Tag',
                },
            ],
            machineSteps: [
                {
                    titleKey: 'home.SignalStep1Title',
                    descKey: 'home.SignalStep1Desc',
                    tags: ['EXNESS', 'VANTAGE', 'Pu Prime', 'TVSI'],
                },
                {
                    titleKey: 'home.SignalStep2Title',
                    descKey: 'home.SignalStep2Desc',
                    tags: ['CONSERVATIVE', 'BALANCED', 'GROWTH'],
                },
                {
                    titleKey: 'home.SignalStep3Title',
                    descKey: 'home.SignalStep3Desc',
                    tags: ['AUTO-TRADE', 'RISK MANAGEMENT'],
                },
                {
                    titleKey: 'home.SignalStep4Title',
                    descKey: 'home.SignalStep4Desc',
                    tags: ['REAL-TIME', 'TRANSPARENT', 'FLEXIBLE'],
                },
            ],
            tradeLogs,
            activeHeroTab: 'shc',
            vnIndexSeries: [
                {date: '31/03/2022', value: 1492.15},
                {date: '30/06/2022', value: 1197.61},
                {date: '30/09/2022', value: 1132.11},
                {date: '31/12/2022', value: 1007.09},
                {date: '31/03/2023', value: 1064.64},
                {date: '30/06/2023', value: 1120.18},
                {date: '30/09/2023', value: 1154.15},
                {date: '31/12/2023', value: 1129.93},
                {date: '29/03/2024', value: 1284.09},
                {date: '28/06/2024', value: 1245.32},
                {date: '30/09/2024', value: 1287.94},
                {date: '31/12/2024', value: 1320.50},
                {date: '31/03/2025', value: 1510.25},
                {date: '30/06/2025', value: 1485.60},
                {date: '30/09/2025', value: 1592.10},
                {date: '31/12/2025', value: 1780.45},
                {date: '31/03/2026', value: 1865.30},
                {date: '08/05/2026', value: 1915.37},
            ],
        };
    },

    computed: {
        heroChart() {
            const W = 800, H = 88;
            const pad = {t: 8, b: 8, l: 4, r: 4};

            let cum = 0;
            const points = [{i: 0, cum: 0, pair: null, profit: null, type: null}];
            heroPanelData.forEach((r, idx) => {
                cum += r.profit;
                points.push({i: idx + 1, cum, pair: r.pair, profit: r.profit, type: r.type});
            });

            const n = points.length;
            const maxCum = Math.max(...points.map(p => p.cum));
            const minCum = Math.min(...points.map(p => p.cum));
            const range = (maxCum - minCum) || 1;
            const chartW = W - pad.l - pad.r;
            const chartH = H - pad.t - pad.b;

            const px = i => pad.l + (i / (n - 1)) * chartW;
            const py = c => pad.t + chartH - ((c - minCum) / range) * chartH;

            const linePts = points.map(p => `${px(p.i).toFixed(1)},${py(p.cum).toFixed(1)}`).join(' ');
            const firstX = px(0).toFixed(1);
            const lastX = px(n - 1).toFixed(1);
            const baseY = (pad.t + chartH).toFixed(1);
            const fillD = `M ${firstX},${baseY} L ${linePts.replace(/(\S+),(\S+)/g, '$1,$2')} L ${lastX},${baseY} Z`;
            const zeroY = py(0).toFixed(1);
            const trend = points[points.length - 1].cum >= 0 ? 'up' : 'down';
            const ptCoords = points.map(p => ({...p, x: px(p.i), y: py(p.cum)}));

            return {W, H, linePts, fillD, zeroY, trend, ptCoords};
        },
        vnIndexChart() {
            const W = 800, H = 88;
            const pad = {t: 8, b: 8, l: 4, r: 4};
            const points = this.vnIndexSeries;
            const n = points.length;
            const maxVal = Math.max(...points.map(p => p.value));
            const minVal = Math.min(...points.map(p => p.value));
            const range = (maxVal - minVal) || 1;
            const chartW = W - pad.l - pad.r;
            const chartH = H - pad.t - pad.b;

            const px = i => pad.l + (i / (n - 1)) * chartW;
            const py = v => pad.t + chartH - ((v - minVal) / range) * chartH;

            const linePts = points.map((p, i) => `${px(i).toFixed(1)},${py(p.value).toFixed(1)}`).join(' ');
            const firstX = px(0).toFixed(1);
            const lastX = px(n - 1).toFixed(1);
            const baseY = (pad.t + chartH).toFixed(1);
            const fillD = `M ${firstX},${baseY} L ${linePts.replace(/(\S+),(\S+)/g, '$1,$2')} L ${lastX},${baseY} Z`;

            const zeroY = py(minVal).toFixed(1);
            const ptCoords = points.map((p, i) => ({x: px(i), y: py(p.value), ...p}));
            return {W, H, linePts, fillD, zeroY, ptCoords};
        },
        vnIndexMeta() {
            const points = this.vnIndexSeries;
            if (!points.length) {
                return {start: 0, latest: 0, change: 0, returnPct: 0};
            }
            const start = points[0].value;
            const latest = points[points.length - 1].value;
            const change = latest - start;
            const returnPct = start ? (change / start) * 100 : 0;
            return {start, latest, change, returnPct};
        },
        vnIndexRows() {
            const points = this.vnIndexSeries;
            if (!points.length) return [];

            const start = points[0];
            const maxVal = Math.max(...points.map(p => p.value));
            const minVal = Math.min(...points.map(p => p.value));
            const toPct = (v) => Math.max(8, Math.round((v / maxVal) * 100));
            const fromStart = (v) => (((v - start.value) / start.value) * 100);

            return points.map((p) => {
                const perf = fromStart(p.value);
                return {
                    date: p.date,
                    value: p.value,
                    perf,
                    widthPct: toPct(p.value),
                    positive: perf >= 0,
                };
            });
        },
        shcMeta() {
            if (!heroPanelData.length) return {deals: 0, win: 0, loss: 0, net: 0, winRate: 0};
            const deals = heroPanelData.length;
            const win = heroPanelData.filter(r => r.profit >= 0).length;
            const loss = deals - win;
            const net = heroPanelData.reduce((s, r) => s + r.profit, 0);
            const winRate = deals ? (win / deals) * 100 : 0;
            return {deals, win, loss, net, winRate};
        },
        shcRows() {
            const maxAbs = Math.max(...heroPanelData.map(r => Math.abs(r.profit)), 1);
            return heroPanelData.map((r, idx) => ({
                date: `#${idx + 1}`,
                labelKey: r.type === 'BUY' ? 'home.vnIndexStart' : 'home.vnIndexLow',
                label: r.type,
                value: Number(r.price),
                perf: r.profit,
                widthPct: Math.max(8, Math.round((Math.abs(r.profit) / maxAbs) * 100)),
                positive: r.profit >= 0,
                pair: r.pair,
            }));
        },
        tradeChart() {
            const toMin = t => {
                const [h, m] = t.split(':').map(Number);
                return h * 60 + m;
            };

            const sorted = [...tradeLogs].sort((a, b) => toMin(a.time) - toMin(b.time));

            // Stats
            const totalProfit = sorted.reduce((s, t) => s + t.profit, 0);
            const wins = sorted.filter(t => t.profit > 0).length;
            const total = sorted.length;
            const maxAbsProfit = Math.max(...sorted.map(t => Math.abs(t.profit)));

            // ── Sparkline: cumulative profit theo thời gian ──────────────────
            const sparkW = 600;
            const sparkH = 84;
            const padS = 8;

            const times = sorted.map(t => toMin(t.time));
            const minT = Math.floor((times[0] - 10) / 30) * 30;
            const maxT = Math.ceil((times[times.length - 1] + 10) / 30) * 30;
            const rangeT = maxT - minT;

            // Cộng dồn profit
            let cum = 0;
            const cumPoints = [{min: minT, cum: 0}];
            sorted.forEach(t => {
                cum += t.profit;
                cumPoints.push({min: toMin(t.time), cum});
            });

            const maxCum = Math.max(...cumPoints.map(p => p.cum));
            const minCum = Math.min(0, Math.min(...cumPoints.map(p => p.cum)));
            const rangeC = (maxCum - minCum) || 1;

            const sx = min => padS + ((min - minT) / rangeT) * (sparkW - padS * 2);
            const sy = c => sparkH - padS - ((c - minCum) / rangeC) * (sparkH - padS * 2);

            const sparkPts = cumPoints.map(p => `${sx(p.min).toFixed(1)},${sy(p.cum).toFixed(1)}`).join(' ');
            // Fill path: đóng xuống đáy
            const firstX = sx(cumPoints[0].min).toFixed(1);
            const lastX = sx(cumPoints[cumPoints.length - 1].min).toFixed(1);
            const baseY = (sparkH - padS).toFixed(1);
            const sparkFill = `M ${firstX},${baseY} L ${sparkPts.replace(/(\d+\.\d+),(\d+\.\d+)/g, '$1,$2')} L ${lastX},${baseY} Z`;

            const sparkPoints = cumPoints.map((p, idx) => ({
                idx,
                min: p.min,
                cum: p.cum,
                time: idx === 0 ? 'Start' : sorted[idx - 1].time,
                pair: idx === 0 ? 'N/A' : sorted[idx - 1].pair,
                profit: idx === 0 ? 0 : sorted[idx - 1].profit,
                x: sx(p.min),
                y: sy(p.cum),
            }));

            // Time grid labels (giờ chẵn) với % position cho CSS
            const timeGrid = [];
            for (let m = minT; m <= maxT; m += 30) {
                const hh = String(Math.floor(m / 60)).padStart(2, '0');
                const mm = String(m % 60).padStart(2, '0');
                timeGrid.push({
                    label: `${hh}:${mm}`,
                    isHour: m % 60 === 0,
                    pct: ((m - minT) / rangeT * 100).toFixed(1),
                });
            }

            return {
                sorted,
                total,
                wins,
                winRate: Math.round(wins / total * 100),
                totalProfit: totalProfit.toFixed(2),
                maxAbsProfit,
                sparkW,
                sparkH,
                sparkLine: sparkPts,
                sparkFill,
                sparkZeroY: sy(0).toFixed(1),
                sparkPoints,
                timeGrid,
            };
        },
        // 3 cột mỗi tháng: V1 (vàng) · V3 (xanh) · Market (xám, có thể âm)
        perfChart() {
            const locale = this.$i18n ? this.$i18n.locale : 'vi';
            const labels = MONTH_LABELS[locale] || MONTH_LABELS['vi'];

            const svgW = 640;
            const svgH = 260;
            const padL = 36;
            const padR = 8;
            const padT = 28;   // chỗ cho value label trên đầu cột
            const padB = 40;   // chỗ cho month label dưới đáy

            const chartW = svgW - padL - padR;
            const chartH = svgH - padT - padB;

            // Scale bao gồm tất cả 3 series (kể cả market âm)
            const allVals = MONTHLY_DATA.flatMap(r => [r.v1, r.v3, r.market]);
            const dataMax = Math.max(...allVals);
            const dataMin = Math.min(...allVals);
            const scaleMax = Math.ceil(dataMax * 1.12 / 10) * 10;
            // scaleMin: nếu âm thì mở rộng thêm 50% để cột âm thấy rõ
            const scaleMin = dataMin < 0 ? Math.floor(dataMin * 1.5 / 5) * 5 : 0;
            const range = scaleMax - scaleMin;

            const toY = val => padT + ((scaleMax - val) / range) * chartH;
            const zeroY = toY(0);

            const n = MONTHLY_DATA.length;
            const groupW = chartW / n;
            // 3 bars + 2 inner gaps, outer margin tự động
            const barW = Math.floor(groupW * 0.22);
            const gap = Math.floor(barW * 0.25);
            const totalBarsW = barW * 3 + gap * 2;

            // Y guides: từ scaleMin đến scaleMax, bước 10 hoặc 5
            const step = scaleMax > 30 ? 10 : 5;
            const guides = [];
            for (let v = scaleMin; v <= scaleMax; v += step) {
                guides.push({val: v, y: toY(v)});
            }

            // Helper: tính rectY và rectH cho bất kỳ giá trị (dương hoặc âm)
            const rectY = val => val >= 0 ? toY(val) : zeroY;
            const rectH = val => Math.max(3, Math.abs(val / range) * chartH);

            // Groups
            const groups = MONTHLY_DATA.map((row, i) => {
                const gx = padL + i * groupW;
                const startX = gx + (groupW - totalBarsW) / 2;
                const cx = gx + groupW / 2;

                const v1X = startX;
                const v3X = startX + barW + gap;
                const mktX = startX + (barW + gap) * 2;

                return {
                    label: labels[i],
                    cx,
                    // V1
                    v1X,
                    v1Y: rectY(row.v1),
                    v1H: rectH(row.v1),
                    v1Val: row.v1,
                    v1LabelY: rectY(row.v1) - 4,
                    // V3
                    v3X,
                    v3Y: rectY(row.v3),
                    v3H: rectH(row.v3),
                    v3Val: row.v3,
                    v3LabelY: rectY(row.v3) - 4,
                    // Market
                    mktX,
                    mktY: rectY(row.market),
                    mktH: rectH(row.market),
                    mktVal: row.market,
                    // label âm thì hiện bên dưới cột
                    mktLabelY: row.market >= 0
                        ? rectY(row.market) - 4
                        : zeroY + rectH(row.market) + 11,
                    isNeg: row.market < 0,
                    // Month label
                    labelY: svgH - padB + 14,
                };
            });

            return {
                svgW, svgH, padL, padR, padT, padB,
                zeroY, guides, groups, barW,
                yMax: scaleMax,
                yMin: scaleMin,
            };
        },
        perfRows() {
            const locale = i18n.global.locale.value || 'vi';
            const labels = MONTH_LABELS[locale] || MONTH_LABELS['vi'];
            const rows = MONTHLY_DATA.map((row, i) => ({
                month: labels[i],
                v1: '+' + row.v1 + '%',
                v3: '+' + row.v3 + '%',
                market: row.market + '%',
                highlight: false,
            }));
            rows.push({
                month: 'YTD 2026',
                v1: '+' + YTD_DATA.v1 + '%',
                v3: '+' + YTD_DATA.v3 + '%',
                market: '~' + YTD_DATA.market + '%',
                highlight: true,
            });
            return rows;
        },

        // Tháng có hiệu suất cao nhất (V3 max)
        bestMonth() {
            const best = MONTHLY_DATA.reduce((a, b) => (b.v3 > a.v3 ? b : a));
            const locale = i18n.global.locale.value || 'vi';
            const labels = MONTH_LABELS[locale] || MONTH_LABELS['vi'];
            const idx = MONTHLY_DATA.indexOf(best);
            return {
                label: labels[idx],
                v1: best.v1,
                v3: best.v3,
            };
        },

        ytd() {
            return YTD_DATA;
        },

        // Vị trí tooltip hero chart — absolute trong container, không bị clip
        heroTooltipStyle() {
            if (!this.heroTooltip) return {};
            const TIP_W = 110;
            const TIP_H = 58;
            const {pxX, pxY, containerW} = this.heroTooltip;

            const left = pxX + TIP_W + 12 > containerW
                ? pxX - TIP_W - 6
                : pxX + 10;
            const top = Math.max(0, pxY - TIP_H / 2);

            return {
                position: 'absolute',
                left: left + 'px',
                top: top + 'px',
                pointerEvents: 'none',
                zIndex: 10,
            };
        },
        sparkTooltipStyle() {
            if (!this.sparkTooltip) return {};
            const TIP_W = 140;
            const TIP_H = 60;
            const {pxX, pxY, containerW} = this.sparkTooltip;

            const left = pxX + TIP_W + 12 > containerW
                ? pxX - TIP_W - 8
                : pxX + 12;
            const top = Math.max(0, pxY - TIP_H / 2);

            return {
                position: 'absolute',
                left: left + 'px',
                top: top + 'px',
                pointerEvents: 'none',
                zIndex: 12,
            };
        },
        vnIndexTooltipStyle() {
            if (!this.vnIndexTooltip) return {};
            const TIP_W = 144;
            const TIP_H = 58;
            const {pxX, pxY, containerW} = this.vnIndexTooltip;
            const left = pxX + TIP_W + 12 > containerW
                ? pxX - TIP_W - 8
                : pxX + 12;
            const top = Math.max(0, pxY - TIP_H / 2);
            return {
                position: 'absolute',
                left: left + 'px',
                top: top + 'px',
                pointerEvents: 'none',
                zIndex: 12,
            };
        },
    },

    methods: {
        t(key) {
            return i18n.global.t(key);
        },
        toggleFaq(index) {
            this.activeFaq = this.activeFaq === index ? null : index;
        },
        showTooltip(event, label, team, val, color) {
            const svg = event.currentTarget.closest('svg');
            const svgRect = svg.getBoundingClientRect();
            const rect = event.currentTarget.getBoundingClientRect();
            this.tooltip = {
                x: rect.left + rect.width / 2 - svgRect.left,
                y: rect.top - svgRect.top - 8,
                label,
                team,
                val,
                color,
            };
        },
        hideTooltip() {
            this.tooltip = null;
        },
        // Hero chart mousemove
        onHeroChartMove(event) {
            this.vnIndexTooltip = null;
            const svg = event.currentTarget;
            const rect = svg.getBoundingClientRect();
            const scaleX = this.heroChart.W / rect.width;
            const mouseX = (event.clientX - rect.left) * scaleX;

            // Tìm điểm gần nhất theo trục X
            const pts = this.heroChart.ptCoords;
            let closest = pts[0];
            let minDist = Math.abs(pts[0].x - mouseX);
            for (const pt of pts) {
                const d = Math.abs(pt.x - mouseX);
                if (d < minDist) {
                    minDist = d;
                    closest = pt;
                }
            }

            if (closest.i === 0) {
                this.heroTooltip = null;
                return;
            }

            // Tính pixel position thực trong container div
            const pxX = closest.x / this.heroChart.W * rect.width;
            const pxY = closest.y / this.heroChart.H * rect.height;

            this.heroTooltip = {
                svgX: closest.x,
                svgY: closest.y,
                pxX,
                pxY,
                containerW: rect.width,
                pair: closest.pair,
                profit: closest.profit,
                cum: closest.cum,
                type: closest.type,
            };
        },
        onHeroChartLeave() {
            this.heroTooltip = null;
        },
        onSparklineMove(event, point) {
            if (!point || point.idx === 0) return;
            const svg = event.currentTarget;
            const rect = svg.getBoundingClientRect();
            const pxX = point.x / this.tradeChart.sparkW * rect.width;
            const pxY = point.y / this.tradeChart.sparkH * rect.height;
            this.sparkTooltip = {
                pxX,
                pxY,
                containerW: rect.width,
                time: point.time,
                pair: point.pair,
                profit: point.profit,
                cum: point.cum,
            };
        },
        onSparklineLeave() {
            this.sparkTooltip = null;
        },
        onVnIndexMove(event) {
            this.heroTooltip = null;
            const svg = event.currentTarget;
            const rect = svg.getBoundingClientRect();
            const scaleX = this.vnIndexChart.W / rect.width;
            const mouseX = (event.clientX - rect.left) * scaleX;

            const pts = this.vnIndexChart.ptCoords;
            let closest = pts[0];
            let minDist = Math.abs(pts[0].x - mouseX);
            for (const pt of pts) {
                const d = Math.abs(pt.x - mouseX);
                if (d < minDist) {
                    minDist = d;
                    closest = pt;
                }
            }

            const pxX = closest.x / this.vnIndexChart.W * rect.width;
            const pxY = closest.y / this.vnIndexChart.H * rect.height;
            const first = this.vnIndexSeries[0]?.value || closest.value;
            const delta = closest.value - first;

            this.vnIndexTooltip = {
                svgX: closest.x,
                svgY: closest.y,
                pxX,
                pxY,
                containerW: rect.width,
                date: closest.date,
                value: closest.value,
                delta,
            };
        },
        onVnIndexLeave() {
            this.vnIndexTooltip = null;
        },
        showMachineTooltip(event, pt) {
            const svg = event.currentTarget.closest('svg');
            const svgRect = svg.getBoundingClientRect();
            const rect = event.currentTarget.getBoundingClientRect();
            this.machineTooltip = {
                x: rect.left + rect.width / 2 - svgRect.left,
                y: Math.min(rect.top - svgRect.top, pt.barY),
                ...pt,
            };
        },
        hideMachineTooltip() {
            this.machineTooltip = null;
        },
    },
};
